import { useState } from "react";
import { FolderX, ChevronDown, ChevronUp } from "lucide-react";
import { inrShort } from "@/pages/Dashboard";

export function UnassignedDiagnosis({ s, testPrefix, isAP }) {
  const [open, setOpen] = useState(false);
  const party = isAP ? "invoices" : "documents";
  return (
    <div className="rounded-lg border border-slate-200 bg-white shadow-sm fade-in-up" data-testid={`${testPrefix}-unassigned-diagnosis`}>
      <button type="button" onClick={() => setOpen((v) => !v)} data-testid={`${testPrefix}-unassigned-toggle`}
        className="w-full flex flex-wrap items-center justify-between gap-3 px-4 py-3 text-left">
        <div className="flex items-center gap-3">
          <div className="h-9 w-9 rounded-md bg-slate-100 flex items-center justify-center shrink-0"><FolderX className="h-5 w-5 text-slate-600" /></div>
          <div>
            <p className="text-sm font-bold text-slate-800">
              Without project / WBS: <span data-testid={`${testPrefix}-unassigned-total`}>{inrShort(s.total)}</span>
              <span className="text-slate-500 font-normal"> · {s.count} lines · {s.share_pct}% of shown total</span>
            </p>
            <p className="text-xs text-slate-500 mt-0.5">
              {s.by_reason.slice(0, 3).map((r) => `${r.reason} ${inrShort(r.total)}`).join(" · ")}
              {s.inferred.count > 0 && <span className="text-amber-700"> · {s.inferred.count} {party} ({inrShort(s.inferred.total)}) assigned from line text</span>}
            </p>
          </div>
        </div>
        {open ? <ChevronUp className="h-4 w-4 text-slate-400" /> : <ChevronDown className="h-4 w-4 text-slate-400" />}
      </button>
      {open && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 px-4 pb-4 text-xs" data-testid={`${testPrefix}-unassigned-detail`}>
          <table className="w-full">
            <thead><tr className="text-[10px] uppercase tracking-wider text-slate-400 text-left"><th className="py-1">Reason</th><th className="py-1 text-right">Lines</th><th className="py-1 text-right">Open (INR)</th></tr></thead>
            <tbody>{s.by_reason.map((r) => (
              <tr key={r.reason} className="border-t border-slate-100" data-testid={`${testPrefix}-unassigned-reason-${r.reason.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}>
                <td className="py-1 text-slate-700">{r.reason}</td><td className="py-1 text-right tabular-nums">{r.count}</td><td className="py-1 text-right font-semibold tabular-nums">{inrShort(r.total)}</td>
              </tr>))}</tbody>
          </table>
          <table className="w-full">
            <thead><tr className="text-[10px] uppercase tracking-wider text-slate-400 text-left"><th className="py-1">SAP doc type</th><th className="py-1 text-right">Lines</th><th className="py-1 text-right">With PO</th><th className="py-1 text-right">Open (INR)</th></tr></thead>
            <tbody>{s.by_doc_type.map((t) => (
              <tr key={t.doc_type} className="border-t border-slate-100" data-testid={`${testPrefix}-unassigned-type-${t.doc_type}`}>
                <td className="py-1 font-mono text-slate-700">{t.doc_type}</td><td className="py-1 text-right tabular-nums">{t.count}</td><td className="py-1 text-right tabular-nums">{t.with_po}</td><td className="py-1 text-right font-semibold tabular-nums">{inrShort(t.total)}</td>
              </tr>))}</tbody>
          </table>
          <p className="md:col-span-2 text-[11px] text-slate-500">
            Project / WBS is read from the expense lines of the SAP document, then from the PO account assignment, and finally inferred from the line text (flagged). Stock POs, opening-balance uploads and payments on account carry no project in SAP.
          </p>
        </div>
      )}
    </div>
  );
}
